export default __webpack_public_path__ + "static/media/P330_SOV.7be557aa.pdf";